<div style="">
  <div class="row">
    <div class="col-md-12 col-sm-12 m-1">
      <p-dataView #dv [value]="ticketsOfLine" [rows]="5" [paginator]="ticketsOfLine.length>0">
        <!--*ngIf="ticketsOfLine.length>0"-->
        <ng-template let-ticket pTemplate="listItem">
          <div class="col-12 ">
            <div class="row">
              <div class="col-6 p-1 "><i class="fas fa-wrench {{getSeverity(ticket)}}"></i>&nbsp;<strong>{{ticket.srNumber}}</strong></div>
              <div class="col-6 p-1 text-right">{{ticket.openedDate | date:'yyyy-MM-dd'}}</div>
              <!--<div class="col-6 p-1 text-right">{{ticket.closedDate | date:'yyyy-MM-dd'}}</div>-->
            </div>
          </div>
        </ng-template>
        <!--<ng-template *ngIf="ticketsOfLine.length===0" pTemplate="footer">
      No Results Found!
    </ng-template>-->
      </p-dataView>

      <div *ngIf="ticketsOfLine.length>0" style="text-align:center">
        <a href="#/line-tickets-full/{{lineQuote}}/{{lineId}}">
          More info <i class="fas fa-arrow-circle-right"></i>
        </a>
      </div>
    </div>
    <!--class="card"-->
    
  </div>


</div>
